export default __webpack_public_path__ + "static/caidio_logo-f9ecdd6021a2fd9a9e859b33afbbde91.png";